import axios from 'axios';

import { API_URL } from '@/config/envVars';
import getLyocCookie from '@/Cookies';
import { logg } from '@/util/logg';

export const axiosClient = axios.create({
	baseURL: API_URL, // API_URL
});

/** i just did this so i didn't have to write the header every time */
function getHeader() {
	const config = {
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded',
			Authorization: `Bearer ${getLyocCookie()}`,
		},
	};

	return config;
}

export async function getUnAuth(url: string) {
	try {
		const response = await axiosClient.get(url);
		return response;
	} catch (error) {
		logg(error);
	}
}

export async function get(url: string) {
	const config = getHeader();
	try {
		const response = await axiosClient.get(url, config);
		return response;
	} catch (error) {
		logg(error);
	}
}

export async function getBlob(url: string) {
	const config = getHeader();
	try {
		const response = await axiosClient.get(url, config);
		return response;
	} catch (error) {
		logg(error);
	}
}

export async function post(url: string, body: any = {}) {
	const config = getHeader();
	try {
		const response = await axiosClient.post(url, body, config);
		return response;
	} catch (error) {
		logg(error);
	}
}
